<template>
  <div id="datepicker-container" class="position-relative">
    <date-picker 
      v-model="newValue" 
      range
      type="date"
      input-class="text-center datePicker"
      valueType="format"
      format="DD-MM-YYYY"
      @change="changeDateValue"
      :append-to-body="false"
    ></date-picker>
  </div>
</template>

<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  export default {
    name:'DateSelector',
    components:{
      DatePicker
    },
    props:{
      date: Array
    },

    data(){
      return {
        newValue: this.date,
      }
    },
    methods:{
      changeDateValue(newDate){
        this.newValue = newDate;
        this.$emit('change', this.newValue);
      },
    },
    computed:{
      displayValue(){
        return this.newValue;
      }
    },
  }
</script>

<style lang="scss">
  .datePicker{
    background: #F4FCF6;
    border: solid #44814E 1.5px;
    
    font-weight: bold;
    border-radius: 5px;
    padding: 5px 4px;
    width: 92.5%;
  }

  .mx-icon-calendar,.mx-icon-clear{
    color: #44814E;
    right: 35px;
  }
</style>